import React from 'react';
import { Link } from 'react-router-dom';
import { useUser } from '../context/UserContext';
import Container from 'react-bootstrap/Container';
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
import NavDropdown from 'react-bootstrap/NavDropdown';



function NavBar() {
    const { user } = useUser();
    

    return (
        <div>
            <header className='bg-purple py-2'>
                <Container>
                    <div className='d-flex flex-column flex-lg-row'>   
                        <div className='mb-3 mb-lg-0 d-flex justify-content-center'>                    
                            <div className='block-w'>
                                <Nav.Link as={Link} to="/" className='h-100'></Nav.Link> 
                            </div>
                        </div> 
                        <div className='d-flex flex-lg-column justify-content-center'>
                            <div className='c2-wordmark'>
                                <Nav.Link as={Link} to="/" className='h-100'></Nav.Link> 
                            </div>   
                        </div>
                        <div className='ms-lg-auto d-flex flex-lg-column justify-content-center'>
                            <div className='pan-wordmark'>
                                <Nav.Link as={Link} to="/" className='h-100'></Nav.Link> 
                            </div>
                        </div>                                 
                    </div>
                </Container>                
            </header>
            <Navbar expand="lg" className="bg-light mb-4" data-bs-theme="light">
                <Container>
                    {/*<Navbar.Brand href="/">Postage Account Management</Navbar.Brand>*/}
                    <Navbar.Toggle aria-controls="main-navbar" />
                    <Navbar.Collapse id="main-navbar">
                        <Nav className="me-auto">
                            <Nav.Link as={Link} to="/postage-account/new">New Postage Account</Nav.Link>
                            {user && (
                                <>
                                <Nav.Link as={Link} to={`/postage-account/user/${user.netId}`}>My Postage Accounts</Nav.Link>
                                <Nav.Link as={Link} to={`/user/${user.netId}`}>My Profile</Nav.Link>
                                </>
                            )}
                            <Nav.Link as={Link} to="/postage-accounts">All Postage Accounts</Nav.Link>
                            <Nav.Link as={Link} to="/search-postage-accounts">Search Postage Accounts</Nav.Link>
                            <Nav.Link as={Link} to="/users">User List</Nav.Link>
                            <Nav.Link as={Link} to="/login">DEV LOGIN</Nav.Link>
                        </Nav>
                    </Navbar.Collapse>
                </Container>        
            </Navbar>
        </div>
    );
}

export default NavBar;
